import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import { PagingArgument } from 'src/lib/utilities/api/patterns/pagination/paging.argument';
import {
	StudentEventsFilter,
	StudentEventsResponseModel,
} from '../../students/events/student-events-response.model';

@Injectable({
	providedIn: 'root',
})
export class UserEventService {
	constructor(private httpClient: HttpClient) {}

	public getEvents = (
		uid: number,
		args: PagingArgument<StudentEventsFilter>,
	): Observable<StudentEventsResponseModel> => {
		return this.httpClient
			.post<unknown>(`/api/v1/user/${uid}/events/created`, args)
			.pipe(
				mapResponse((r) => plainToInstance(StudentEventsResponseModel, r), {
					errorCode: '1CA036AF',
				}),
			);
	};
}
